import { render, staticRenderFns } from "./ViewInsights.vue?vue&type=template&id=7fd20c0e&scoped=true"
import script from "./ViewInsights.vue?vue&type=script&lang=js"
export * from "./ViewInsights.vue?vue&type=script&lang=js"
import style0 from "./ViewInsights.vue?vue&type=style&index=0&id=7fd20c0e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fd20c0e",
  null
  
)

export default component.exports